import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { publicStories } from "../../lib/api";
import { StoryCard } from "../../pages/Stories";
import { tr } from "../../lib/i18n";

// Landing: up to three published case studies. Renders nothing until one is live.
export const StoriesStrip = () => {
  const { data } = useQuery({ queryKey: ["public-stories"], queryFn: publicStories, staleTime: 600000, retry: false });
  if (!data?.items?.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-6 py-20" data-testid="stories-strip">
      <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-primary">{tr("Stories")}</div>
      <div className="flex flex-wrap items-end gap-4 mt-2"><h2 className="font-serif text-3xl sm:text-4xl">{tr("What it looks like when it's handled")}</h2><Link to="/stories" className="pb-1 ml-auto text-sm text-primary hover:underline" data-testid="stories-strip-all">{tr("All stories")} →</Link></div>
      <div className="mt-8 grid md:grid-cols-3 gap-4">{data.items.slice(0, 3).map((s) => <StoryCard key={s.id} s={s} />)}</div>
    </section>
  );
};
